export class PaletteLimitDTO {
  id: number;
  productId: number;
  paletteId: number;
  stockLimit: number;
  minimumQuantityForPreOrder: number;
  minimumQuantityForReOrder: number;
  constructor(init?: PaletteLimitDTO) {
    Object.assign(this, init);
  }
}
